import { Navigate, useSearchParams } from 'react-router-dom';

// /search?q=<term> (old and external links; also ?query=) -> /search/<term>. Other params (kind, game, ...) are kept.
export default function SearchRedirect() {
  const [params] = useSearchParams();
  const term = (params.get('q') || params.get('query') || '').trim();
  if (!term) return <Navigate to="/" replace />;
  const rest = new URLSearchParams(params);
  rest.delete('q');
  rest.delete('query');
  const qs = rest.toString();
  return <Navigate to={`/search/${encodeURIComponent(term)}${qs ? `?${qs}` : ''}`} replace />;
}
